// main.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import Modal from 'react-modal';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AlertProvider from './utils/AlertContext';
import { LoadingProvider } from './utils/contexts/LoadingContext';
import "@fontsource/oswald/200.css"; // Default weight 400
import "@fontsource/oswald/300.css"; // Weight 500
import "@fontsource/oswald/400.css"; // Weight 600
import "@fontsource/oswald/500.css"; // Weight 700
import "@fontsource/oswald/600.css"; // Weight 700
import "@fontsource/oswald/700.css"; // Weight 700

// Initialize the QueryClient for React Query
const queryClient = new QueryClient();

// Set up the Modal root element
const container = document.getElementById('root');
const root = createRoot(container!);

// Set Modal's root element
Modal.setAppElement('#root');

// Render the application with React Query support and React Query Devtools
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AlertProvider>
        <LoadingProvider>
          <App /> {/* Ensure App is wrapped in QueryClientProvider */}
          <ReactQueryDevtools initialIsOpen={false} />
        </LoadingProvider>
      </AlertProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
